import { Api } from '../../common/api/const';
import { UserCV } from '../../users/model';
import UserCvDTO from '../../users/model/dto-get/userCvDTO';

const mapToDTO = (cv: UserCV): UserCvDTO => {
  return {
    user: cv.user,
    books: [], // TODO: Books were never implemented
    projects: cv.projects?.map((project) => {
      return {
        ...project,
        description: JSON.stringify(project.description || []),
        client: {
          ...project.client,
        },
        skills: project.skills?.map((skill) => {
          return {
            ...skill,
          };
        }),
        tasks: project.tasks?.map((task, index) => ({
          priority: index,
          name: task,
        })),
      }
    }),
    skills: cv.skills?.map((skill) => {
      return {
        ...skill
      };
    }),
    education: cv.educations?.map((education) => {
      return {
        ...education,
        description: JSON.stringify(education.description || []),
      };
    }),
    trainings: cv.trainings?.map((training) => {
      return {
        ...training,
        description: JSON.stringify(training.description || []),
      };
    }),
    certificates: cv.certificates?.map((certificate) => {
      return {
        ...certificate,
        description: JSON.stringify(certificate.description || []),
      }
    }),
    weblinks: cv.links?.map((link) => {
      return {
        ...link,
      }
    }),
    userInfo: {
      ...cv.userInfo,
      about: JSON.stringify(cv.userInfo?.about || []),
    },
    languages: cv.languages?.map((language) => {
      return {
        ...language,
      }
    }),
  }
}


export class DownloadPdfService {
  static downloadPdf = (cv: UserCV) => {
    const body = {
      metadata: {
        format: 'PDF',
      },
      cv: mapToDTO(cv),
    };
    return Api().post('/cv/export', body, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(res => {
      const fileName = res.headers['content-disposition']?.split('filename=')[1].replace(/"/g, '');
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName)

      document.body.appendChild(link)
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    });
  };
}
